// benefitsValidation.js

import { check_ben_brothers, checkEmployee } from "../activity";

import { parseCertificate } from '../widgets/certificate/certificateParser';

const benefits_fixed_kg = [
  "5bfb996f0b7fb2059b8828c9",
  "5c16b5a22f8be751f04fce92",
  "60e81561904ae40729056dc4"
];


// Функция проверки украинского имени
const validateUkrainianName = (name) => {
  if (!name) return false;
  
  const ukrainianRegex = /^[А-ЩЬЮЯҐЄІЇа-щьюяґєії'\s-\.]+$/;
  return ukrainianRegex.test(name);
};

// Функция проверки даты (не может быть в будущем)
const validateNotFutureDate = (date) => {
  if (!date) return false;
  
  const inputDate = new Date(date);
  const today = new Date();
  today.setHours(23, 59, 59, 999); // Конец дня сегодня
  
  return inputDate <= today;
};

// Функция проверки возраста (не старше 8 лет)
const validateChildAge = (birthDate, maxAge = 8) => {
  if (!birthDate) return false;
  
  const birth = new Date(birthDate);
  const today = new Date();
  
  let age = today.getFullYear() - birth.getFullYear();
  const monthDiff = today.getMonth() - birth.getMonth();
  
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
    age--;
  }
  
  return age <= maxAge;
};

// Функция проверки РНОКПП (10 цифр)
const validateRnokpp = (rnokpp) => {
  if (!rnokpp) return false;
  
  const rnokppRegex = /^\d{10}$/;
  return rnokppRegex.test(rnokpp);
};

// Функция проверки номера свидетельства о рождении
const validateBirthCertificate = (certificate) => {
  if (!certificate) return false;
  
  const certificateRegex = /^[А-Я,A-Z,І]{1}-[А-Я, A-Z,І]{2}-\d{6}$/;
  return certificateRegex.test(certificate);
};

const cyrillicToLatin = {
    'А': 'A', 'В': 'B', 'С': 'C', 'Е': 'E', 'Н': 'H',
    'І': 'I', 'К': 'K', 'М': 'M', 'О': 'O', 'Р': 'P',
    'Т': 'T', 'Х': 'X'
};

function normalizeCertNumber(str) {
    return str
        .toUpperCase()
        .split('')
        .map(ch => cyrillicToLatin[ch] || ch)
        .join('')
        .trim();
}

// Основная функция валидации формы пільг
export const validateBenefitsForm = async (formData) => {
  const errors = {};
  const benefits = formData.benefits || {};

  // Если пільга выбрана, проводим полную валидацию
  if (benefits.type) {
    const selectedBenefit = benefits.type.toLowerCase();

    // Проверка для обычных пільг (с документами)
    if (!benefits_fixed_kg.includes(selectedBenefit)) {
      
      if (!benefits.documentType) {
        errors.benefitsDocumentType = 'Тип документа обов\'язковий';
      }

      if (!benefits.documentNumber) {
        errors.benefitsDocumentNumber = 'Номер документа обов\'язковий';
      }

      if (!benefits.issuedTo) {
        errors.benefitsIssuedTo = 'Поле "Кому видано" обов\'язкове';
      } else if (!validateUkrainianName(benefits.issuedTo)) {
        errors.benefitsIssuedTo = 'ПІБ має містити тільки українські літери';
      }

      if (!benefits.issueDate) {
        errors.benefitsIssueDate = 'Дата видачі обов\'язкова';
      } else if (!validateNotFutureDate(benefits.issueDate)) {
        errors.benefitsIssueDate = 'Дата видачі не може бути у майбутньому';
      }

      if (!benefits.files || benefits.files.length === 0) {
        errors.benefitsFiles = 'Фото чи скан-копія документа обов\'язкові';
      }
    }

    // Проверка для пільги "Територія обслуговування"
    if (selectedBenefit == '60e81561904ae40729056dc4') {
      if (!benefits.address) {
        errors.benefitsaddress = 'Адреса проживання обов\'язкова';
      }
    }

    // Проверка для пільги "Брати та сестри в одному ЗДО"
    if (selectedBenefit == '5bfb996f0b7fb2059b8828c9') {
      if (!benefits.kindergarten) {
        errors.benefitsKindergarten = 'Заклад дошкільної освіти обов\'язковий';
      }

      if (!benefits.siblingBirthCertificate) {
        errors.benefitsSiblingBirthCertificate = 'Номер свідоцтва про народження обов\'язковий';
      } 
      //else if (!validateBirthCertificate(benefits.siblingBirthCertificate)) {
      //  errors.benefitsSiblingBirthCertificate = 'Номер свідоцтва має бути у форматі: А-АА-123456';
      //}

      if (!benefits.siblingName) {
        errors.benefitsSiblingName = 'Ім\'я дитини обов\'язкове';
      } else if (!validateUkrainianName(benefits.siblingName)) {
        errors.benefitsSiblingName = 'Ім\'я дитини має містити тільки українські літери';
      }

      if (!benefits.siblingBirthDate) {
        errors.benefitsSiblingBirthDate = 'Дата народження дитини обов\'язкова';
      } else if (!validateChildAge(benefits.siblingBirthDate)) {
        errors.benefitsSiblingBirthDate = 'Вік дитини не може перевищувати 8 років';
      }


      const getCert = (txt)=>{
        //const ukr_cert = parseCertificate(txt);
        //if(ukr_cert.number && ukr_cert.series && ukr_cert.subSeries) return [ukr_cert.series, ukr_cert.subSeries, ukr_cert.number].join("-");
        return txt;
      }
            
      const result_pres = await check_ben_brothers(
        benefits.kindergarten, 
        getCert(benefits.siblingBirthCertificate),
        benefits.siblingName,
        benefits.siblingBirthDate
      );

      if(!result_pres.data || !result_pres.data.found || result_pres.data.found == false ){
        errors.benefitsSiblingBirthCertificate = 'Не знайдено інформацію про брата(сестру) в цьому садочку'
        errors.benefitsSiblingName = 'Не знайдено інформацію про брата(сестру) в цьому садочку'
      }

      

    }

    // Проверка для пільги "Діти працівників закладу"
    if (selectedBenefit == "5c16b5a22f8be751f04fce92") {
      if (!benefits.kindergarten) {
        errors.benefitsKindergarten = 'Заклад дошкільної освіти обов\'язковий';
      }

      if (!benefits.employeeName) {
        errors.benefitsEmployeeName = 'Ім\'я працівника обов\'язкове';
      } else if (!validateUkrainianName(benefits.employeeName)) {
        errors.benefitsEmployeeName = 'Ім\'я працівника має містити тільки українські літери';
      }

      if (!benefits.employeeRnokpp) {
        errors.benefitsEmployeeRnokpp = 'РНОКПП працівника обов\'язковий';
      } else if (!validateRnokpp(benefits.employeeRnokpp)) {
        errors.benefitsEmployeeRnokpp = 'РНОКПП має містити рівно 10 цифр';
      }

      const result_pres = await checkEmployee(benefits.kindergarten, benefits.employeeRnokpp, benefits.employeeName);

      if(!result_pres.data || !result_pres.data.found || result_pres.data.found == false ){
        errors.benefitsEmployeeName = 'Не знайдено інформацію працівника в цьому садочку'
        errors.benefitsEmployeeRnokpp = 'Не знайдено інформацію працівника в цьому садочку'
      }
    }

  }


  return errors;

  
};

// Вспомогательная функция для проверки, есть ли ошибки
export const hasBenefitsErrors = (errors) => {
  return Object.keys(errors).length > 0;
};

export default {
  validateBenefitsForm,
  hasBenefitsErrors,
  validateUkrainianName,
  validateNotFutureDate,
  validateChildAge,
  validateRnokpp,
  validateBirthCertificate
};